import React from 'react';
import './Research.css';

const Research = () => {
  const researchAreas = [
    {
      title: 'Multi-stream neural architectures',
      description: 'Exploring parallel processing pathways within networks that enable specialized computation and dynamic resource allocation.'
    },
    {
      title: 'Stability-optimized routing',
      description: 'Developing routing mechanisms that maintain training stability while enabling flexible information flow between network modules.'
    },
    {
      title: 'Interpretability via architectural decomposition',
      description: 'Leveraging structural modularity to enable post-hoc analysis, visualization, and understanding of learned representations.'
    }
  ];

  return (
    <section className="section research-section">
      <h2 className="section-title">Research Directions</h2>
      
      <div className="research-list">
        {researchAreas.map((area, index) => (
          <div key={index} className="research-item">
            <h3 className="research-item-title">{area.title}</h3>
            <p className="research-item-description">{area.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Research;